// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__SiiMV","alertIcon":"ConfirmModal_alertIcon__ymoWn"};